
module Meevo.Plugins.ServicesWizard {
    export class LaunchServicesController {

        static $inject = [
            "$rootScope",
            "$window",
            "$mdDialog",
            "$translate",
            "showInfo",
            "isImported",
            "hasNoServices"
        ];

        constructor(private $rootScope: ng.IRootScopeService,
            private $window: angular.IWindowService,
            private $mdDialog: angular.material.IDialogService,
            private $translate: angular.translate.ITranslateService,
            private showInfo: boolean,
            private isImported: boolean,
            private hasNoServices:boolean) {

        }

        gotoServiceWizard = (): void => {
            this.close(true);
        }

        close(action: boolean) {
            if (action)
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                    stateName: 'servicesWizard',
                    stateParams: {}
                })
            return this.$mdDialog.hide(action);
        }

    }

    angular.module("meevo.plugins.servicesWizard")
        .controller("meevo.plugins.servicesWizard.LaunchServicesController", LaunchServicesController);
}